
import OrbButton from "../../../../shared/components/orb-button";
import { LoginvalidationSchema } from "../../../../shared/components/schema-validation/schema-validation";
import { yupResolver } from "@hookform/resolvers/yup";

import { Controller, useForm } from "react-hook-form";

import OrbInput from "../../../../shared/forms/orb-input";
import { authConfig, loginFormDetails } from "../../auth-config";
import { useTranslation } from "react-i18next";
import { LoginInput, loginProps } from "../../auth-interface";

const Login = (props: loginProps) => {
  const { setSelectedDetails, save, loginLoading } = props;
  const { t } = useTranslation();

  const defaultValues = {
    usr_email: "",
    usr_password: "",
  };
  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<any>({
    defaultValues: defaultValues as LoginInput,
    resolver: yupResolver(LoginvalidationSchema),
  });

  const handleSwitch = (type: any) => {
    setSelectedDetails(authConfig[type]);
  };

  const onSubmit = (data: any) => {
    save(data, authConfig.login.id);
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        {loginFormDetails.map((field: any) => {
          return (
            <div key={field.name}>
              <Controller
                name={field.name}
                control={control}
                render={({ field: { onChange, value } }) => {
                  return (
                    <OrbInput
                      type={field.type}
                      placeholder={t(field.placeholder)}
                      value={value}
                      onChange={onChange}
                      errorMessage={errors?.[field.name]?.message ?? ""}
                      label={t(field.label)}
                    />
                  );
                }}
              />
            </div>
          );
        })}
        <div className="d-flex justify-content-between">
          <p className=" mohave sub-font m-1">
            {t(`don't_have_an_account?`)}{" "}
            <a
              className=" pointer link"
              onClick={() => handleSwitch("register")}
            >
              {t("register_now")}
            </a>
          </p>
          <p className=" mohave sub-font m-1">
            {t("forgot?")}
            <a
              className="pointer link"
              onClick={() => handleSwitch("verify_email")}
            >
              {t("password")}
            </a>
          </p>
        </div>

        <div className="pt-2 d-flex justify-content-end">
          <OrbButton
            type={"submit"}
            label={t('submit')}
            iconName={"check"}
            loading={loginLoading}
          />
        </div>
      </form>
    </>
  );
};

export default Login;
